import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// login
import LoginReducer from "./auth/login/reducer";

// register
import RegisterReducer from "./auth/register/reducer";

// chat
import ChatReducer from "./chat/reducer";

// contact
import ContactReducer from "./contact/reducer";

// Users
import UsersReducer from "./users/reducer";

// Calendar
import CalendarReducer from "./calendar/reducer";

// Campaign
import CampaignReducer from "./campaign/reducer";
// Workflow
import WorkflowReducer from "./workflow/reducer";

// Knowledge
import KnowledgeReducer from "./knowledge/reducer";

// Communication (internal 1:1 chat)
import CommunicationReducer from "./communication/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Register: RegisterReducer,
  Chat: ChatReducer,
  Contact: ContactReducer,
  Workflow: WorkflowReducer,
  Users: UsersReducer,
  Calendar: CalendarReducer,
  Campaign: CampaignReducer,
  Knowledge: KnowledgeReducer,
  Communication: CommunicationReducer,
});


export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;